import React, { Fragment, useState } from 'react';

import StatementsPanel from "../components/ui/panel-statements.js";
import DocumentPreview from '../components/ui/document-preview-panel.js';
import UploadStatementsDialog from "../components/ui/dialog-upload-statements.js"
import { useGetQuotaByName } from "../api/quotas";


import { Stack } from "@mui/material";
import CurrentCaseRequired from "../components/ui/current-case-required.js";
import CaseDatabaseCheck from "../components/ui/case-database-check.js";
import styles from './page-manage-uploaded-documents.module.css';

function ManageUploadedFilesView() {


  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  // const pageQuotaResult = useGetQuotaByName('Scanned Document Pages')


  const handleUploadClick = (data) => {
    setOpenUploadDialog(true);
  };



  const onCancelUpload = () => {
    setOpenUploadDialog(false);
  };

  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <StatementsPanel>
          <Stack spacing={2}>
            <DocumentPreview handleUploadClick={handleUploadClick}
            //  pageQuotaResult={pageQuotaResult}
             />
          </Stack>
        </StatementsPanel>
      </div>
      <UploadStatementsDialog open={openUploadDialog} onCancel={onCancelUpload}
        // pageQuotaResult={pageQuotaResult}
        />
    </div>
  );
};

export default function ManageUploadedFiles() {
  return (
    <CaseDatabaseCheck>
    <CurrentCaseRequired>
      <ManageUploadedFilesView />
    </CurrentCaseRequired>
    </CaseDatabaseCheck>
  );
}
